/* eslint-disable array-callback-return */
import React, { useState, useMemo, useEffect } from 'react'
import TableItem from './TableItem'
import { Resizable } from 're-resizable'
import { useLang } from '../../../../_metronic/i18n/Metronici18n';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import { KTSVG } from '../../../../_metronic/helpers';
import NoDatas from '../../../components/NoDatas';
import Pagenation from '../../../components/pagination/Pagenation';
import { alphabetically } from '../../../../setup/utils/utils';
import { useAuth } from '../../../../setup/context/AppContext';
import { UserModel } from '../../auth/models/UserModel';
import { shallowEqual } from 'react-redux';
import { RootState } from '../../../../setup';
import { useSelector } from 'react-redux';
import { getSearchDataByIds, requestSqlVersionQuery, requestXmlVersionQuery } from '../redux/SearchFilterCRUD';
import { useDispatch } from 'react-redux';
import * as search from '../redux/SearchFilterRedux'
import { applyScript, getAppliedScriptData } from '../../customer/redux/CustomerCRUD';
import { uploadAll } from '../../updateTableXML/redux/UpdateTableXMLCRUD';
var XMLParser = require('react-xml-parser');

const SearchResults = (props: any) => {
  const { totalData, loading, handleNext, headers, definitions, options, searchcolumns, serverStatus, handleDelete } = props;
  const {
    requestSqlVersion,
    setRequestSqlVersion,
    applySqlUpdates,
    setApplySqlUpdates,
    setApplingSystem,
    setApplyingScriptName,
    requestXmlVersion,
    setRequestXmlVersion,
    applyXmlUpdates,
    setApplyXmlUpdates
  } = useAuth();

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalColumnItems, setTotalColumnItems] = useState<any[]>(totalData);
  const [sortAsc, setSortASC] = useState<any>();
  const [currentsort, setCurrentSort] = useState<string>("")
  const [columnWidthsObj, setColumnWidthsObj] = useState<any>({});
  const [companyIds, setCompanyIds] = useState<any[]>([]);
  let minColumnWidthsObj: any = {};

  const lang = useLang()

  useEffect(() => {
    const ids = totalData.map((item: any) => item.id);
    setCompanyIds(ids);
  }, [totalData])

  const handleRequestSqlVersionQuery = async () => {
    const saltid = user?.saltid;
    const salt = user?.salt;
    let ids = '';
    if (companyIds.length > 0) {
      ids = "'" + companyIds.join("','") + "'";
    }
    const body = { companyIds, salt, saltid };
    const body2 = { ids, salt, saltid };
    try {
      await requestSqlVersionQuery(body);
      const res = await getSearchDataByIds(body2);
      const data1 = res.data;
      dispatch(search.actions.getSearchTableData(data1))
      setRequestSqlVersion(false);
    } catch (error) {
      setRequestSqlVersion(false);
    }
  }

  const handleRequestXMLVersionQuery = async () => {
    const saltid = user?.saltid;
    const salt = user?.salt;
    let ids = '';
    if (companyIds.length > 0) {
      ids = "'" + companyIds.join("','") + "'";
    }
    const body2 = { ids, salt, saltid };

    for (let j = 0; j < totalData.length; j++) {
      const element = totalData[j];
      setApplingSystem(element);
      setApplyingScriptName("")
      try {
        const body = { companyid: element.id, salt, saltid };
        await requestXmlVersionQuery(body);
        const res = await getSearchDataByIds(body2);
        const data1 = res.data;
        dispatch(search.actions.getSearchTableData(data1))
      } catch (error) {

      }
    }
    setRequestXmlVersion(false);
  }

  const getAppliedScripts = async (id: any) => {
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, salt, saltid };

    try {
      const res = await getAppliedScriptData(body)
      return res.data;
    } catch (error) {
      return null
    }
  }

  const handleUploadAll = async (id: any) => {
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, salt, saltid }
    try {
      const res = await uploadAll(body)
      return res.data;
    } catch (error) {
      return null
    }
  }

  const handleApplyScript = async (id: any, scripts: any) => {
    const items = [...scripts].sort(alphabetically('scriptname', true));
    const saltid = user?.saltid;
    const salt = user?.salt;
    for (let i = 0; i < items.length; i++) {
      const element = items[i];
      const body = { id, scriptid: element.id, salt, saltid }
      try {
        setApplyingScriptName(element.scriptname);
        const { data } = await applyScript(body);
        if (data.code === 0) {
          break;;
        }
      } catch (error) {
        break;;
      }
    }
  }

  const handleApplyAllSQL = async () => {
    const filters = totalData.filter((item: any) => item.should_update === true);
    const salt = user?.salt;
    const saltid = user?.saltid;
    for (let i = 0; i < filters.length; i++) {
      const element = filters[i];
      setApplingSystem(element);
      const scripts = await getAppliedScripts(element.id);
      await handleApplyScript(element.id, scripts.appliableScripts)
    }

    let ids = '';
    if (companyIds.length > 0) {
      ids = "'" + companyIds.join("','") + "'";
    }
    const body2 = { ids, salt, saltid };
    try {
      const res = await getSearchDataByIds(body2);
      const data1 = res.data;
      dispatch(search.actions.getSearchTableData(data1))
    } catch (error) {
    }
    setApplySqlUpdates(false);
    setApplingSystem(null);
  }

  const handleApplyAllXML = async () => {
    const filters = totalData.filter((item: any) => item.should_update === true);
    const salt = user?.salt;
    const saltid = user?.saltid;
    for (let i = 0; i < filters.length; i++) {
      const element = filters[i];
      setApplingSystem(element);
      setApplyingScriptName("")
      await handleUploadAll(element.id)
    }

    let ids = '';
    if (companyIds.length > 0) {
      ids = "'" + companyIds.join("','") + "'";
    }
    const body2 = { ids, salt, saltid };
    try {
      const res = await getSearchDataByIds(body2);
      const data1 = res.data;
      dispatch(search.actions.getSearchTableData(data1))
    } catch (error) {
    }
    setApplyXmlUpdates(false);
    setApplingSystem(null);
  }

  useEffect(() => {
    if (requestSqlVersion) {
      handleRequestSqlVersionQuery();
    }
    //eslint-disable-next-line
  }, [requestSqlVersion])

  useEffect(() => {
    if (requestXmlVersion) {
      handleRequestXMLVersionQuery();
    }
    //eslint-disable-next-line
  }, [requestXmlVersion])

  useEffect(() => {
    if (applySqlUpdates) {
      handleApplyAllSQL();
    }
    //eslint-disable-next-line
  }, [applySqlUpdates])

  useEffect(() => {
    if (applyXmlUpdates) {
      handleApplyAllXML();
    }
    //eslint-disable-next-line
  }, [applyXmlUpdates])

  useEffect(() => {
    let sort: any = [];
    searchcolumns.forEach((element: any) => {
      sort[element.field] = false;
    });

    setSortASC(sort);
  }, [searchcolumns])

  useEffect(() => {
    const gridColumns = headers.map(() => {
      return 0;
    });
    setColumnWidthsObj(gridColumns.reduce((result: any, current: any, index: any) => {
      result[index] = current;
      return result;
    }, {}))
  }, [headers])


  let PageSize = 40;
  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return totalColumnItems?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, totalColumnItems, PageSize]);

  const handlePageChange = (props: any) => {
    let page = parseInt(props);
    let itemscount = (page - 1) * PageSize;
    if (itemscount < totalColumnItems.length) {
      setCurrentPage(page);
    } else {
      setCurrentPage(currentPage + 1)
    }
  }

  useEffect(() => {
    setTotalColumnItems(totalData);
    totalData?.forEach((element: any) => {
      const cstatus = serverStatus[element.id];
      element['serverconnection'] = cstatus;
      if (!element['should_update']) {
        element['should_update'] = false;
      }
    });
    // eslint-disable-next-line
  }, [totalData, serverStatus])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [currentPage])

  const handleSort = (field: string, flag: boolean) => {
    setCurrentSort(field);
    const items = [...totalColumnItems].sort(alphabetically(field, flag));
    setTotalColumnItems(items);
    let sort = sortAsc;
    sort[field] = !flag;
    setSortASC(sort);
  }

  const handleChangeWidth = (e: any, id: any) => {
    let currentwidth = columnWidthsObj[id] + e.width;
    if (columnWidthsObj[id] === 0) {
      currentwidth = minColumnWidthsObj[id] + e.width;
    }
    if (50 <= currentwidth) {
      const updateItems = {
        ...columnWidthsObj,
        [id]: currentwidth
      }
      setColumnWidthsObj(() => updateItems)
    } else {
      const updateItems = {
        ...columnWidthsObj,
        [id]: 50
      }
      setColumnWidthsObj(() => updateItems)
    }
  }

  useEffect(() => {
    if (searchcolumns) {
      const gridColumns = searchcolumns.map(() => {
        return 0;
      });
      setColumnWidthsObj(gridColumns.reduce((result: any, current: any, index: any) => {
        result[index] = current;
        return result;
      }, {}))
    }
    // eslint-disable-next-line 
  }, [searchcolumns])

  const handleChangeMinWidth = (width: any, id: any) => {
    const updateItems = {
      ...minColumnWidthsObj,
      [id]: width
    }
    minColumnWidthsObj = updateItems;
  }

  return (
    <>
      <div className='w-100' style={{ overflow: 'auto' }}>
        <table className='table table-row-dashed  table-bordered table-hover table-checkable table-row-gray-300 align-middle gs-0 gy-4'
          style={{ border: '1px solid #dfdbdb' }}
        >
          <thead>
            <tr className='text-dark'>
              {
                searchcolumns.map((item: any, index: number) => {
                  if (definitions[index]) {
                    const definition = definitions[index].definition;
                    const xml = new XMLParser().parseFromString(definition);
                    const filter = xml.children.filter((item: any) => item.name === 'gridwidth')
                    let width = 150;
                    if (filter[0]) {
                      width = 1.5 * parseInt(filter[0].value);
                      if (width < 50) {
                        width = 50;
                      }
                    }
                    let Field = item[lang];
                    if (item['field'] === "serverconnection") {
                      Field = "C"
                    } else if (item['field'] === "statusconcerned") {
                      Field = "P"
                    }

                    handleChangeMinWidth(width, index);
                    if (sortAsc) {
                      return (
                        <th
                          key={index}
                          title={item[lang]}
                          className='overflow-hidden text-left'
                          style={{ padding: '0px', cursor: 'pointer', position: 'relative', whiteSpace: 'nowrap' }}
                          onClick={() => handleSort(item['field'], sortAsc[item.field])}
                        >
                          <Resizable
                            className="resize-content"
                            style={{ padding: '10px' }}
                            size={{ width: columnWidthsObj[index] > 0 ? columnWidthsObj[index] : width, height: '' }}
                            enable={
                              {
                                "top": false,
                                "right": true,
                                "bottom": false,
                                "left": false,
                                "topRight": false,
                                "bottomRight": false,
                                "bottomLeft": false,
                                "topLeft": false
                              }
                            }
                            onResizeStop={(e, direction, ref, d) => {
                              handleChangeWidth(d, index)
                            }}
                          >
                            {
                              currentsort === item['field'] ?
                                <div className='d-flex justify-content-between text-primary' style={{ overflow: 'hidden', lineHeight: '20px' }}>
                                  {Field}
                                  {
                                    sortAsc[item.field] ?
                                      <KTSVG
                                        className="svg-icon svg-icon-1 svg-icon-primary"
                                        path="/media/icons/duotune/arrows/arr073.svg"
                                      /> :
                                      <KTSVG
                                        className="svg-icon svg-icon-1 svg-icon-primary"
                                        path="/media/icons/duotune/arrows/arr072.svg"
                                      />
                                  }
                                </div> :
                                <div className='d-flex justify-content-between ' style={{ overflow: 'hidden', lineHeight: '20px' }}>
                                  {Field}
                                  {
                                    sortAsc[item.field] ?
                                      <KTSVG
                                        className="svg-icon svg-icon-1 svg-icon-primary"
                                        path="/media/icons/duotune/arrows/arr073.svg"
                                      /> :
                                      <KTSVG
                                        className="svg-icon svg-icon-1 svg-icon-primary"
                                        path="/media/icons/duotune/arrows/arr072.svg"
                                      />
                                  }
                                </div>
                            }
                          </Resizable>
                        </th>
                      )
                    }
                  }
                })
              }
              <th
                className='w-40px overflow-hidden text-left'
                style={{ padding: '0px', cursor: 'pointer', position: 'relative', whiteSpace: 'nowrap' }}
              ></th>
            </tr>
          </thead>
          <tbody>
            {
              currentTableData?.length > 0 ?
                currentTableData?.map((item: any, index: number) => {
                  return (
                    <TableItem
                      key={item.id}
                      indexing={index}
                      data={item}
                      loading={loading}
                      headers={headers}
                      definitions={definitions}
                      serverStatus={serverStatus[item.id]}
                      options={options}
                      columnNames={searchcolumns}
                      handleNext={handleNext}
                      handleDelete={handleDelete}
                    />
                  );
                }) : (
                  <NoDatas />
                )
            }
          </tbody>
        </table>
      </div>
      <Pagenation
        currentPage={currentPage}
        totalCount={totalColumnItems.length}
        pageSize={PageSize}
        onPageChange={handlePageChange}
      />
    </>
  )
}

export { SearchResults }
